export default __webpack_public_path__ + "static/media/Maithili_cm_1.6994f3bd.mp3";